import { ID } from "../../../shared/interfaces";

export class BaseModel {
    id: ID;
}
